
import { mapState, mapMutations } from 'vuex'

function buildSteps(
  isLoggedIn = false,
  showPlatformSelection = false,
  /* eslint-disable-next-line */
  { step_title_login, step_title_enter_code, step_title_success } = {}
) {
  return [
    ...(isLoggedIn
      ? []
      : [
          {
            titleKey: 'login',
            title: step_title_login,
            route: { name: 'coupons-redeem-login' },
          },
        ]),

    {
      titleKey: 'enter-coupon',
      title: step_title_enter_code,
      route: { name: 'coupons-redeem' },
      routeAliases: showPlatformSelection
        ? [
            {
              name: 'coupons-redeem-coupon-coupon-platform',
              params: { coupon: '' },
            },
          ]
        : [],
    },
    {
      titleKey: 'open-e-teaching-material',
      title: step_title_success,
      route: { name: 'coupons-redeem-coupon', params: { coupon: '' } },
    },
  ]
}

export default {
  async asyncData({ store, $auth, route }) {
    const redeemCouponPageSettings = await store.dispatch(
      'global/loadRedeemCouponPageSettings'
    )

    let coupon = null
    try {
      coupon = await store.dispatch('coupons/getDetails', route.params.coupon)
      store.commit('coupons/setCoupon', coupon)
    } catch (error) {
      console.log({ error })
    }

    return {
      steps: buildSteps(
        $auth.loggedIn,
        coupon?.has_multiple_supported_coupon_platforms,
        redeemCouponPageSettings
      ),
    }
  },

  head() {
    return {
      title: this.redeemCouponPageSettings.title,
    }
  },

  computed: {
    ...mapState('global', ['redeemCouponPageSettings']),
    ...mapState('coupons', ['coupon']),
  },

  watch: {
    '$auth.loggedIn'(isLoggedIn) {
      // Only rebuild (add login step) if the user suddenly is not authenticated.
      // Do not remove login step if user just logged in.
      if (!isLoggedIn) {
        this.steps = buildSteps(
          isLoggedIn,
          this.coupon?.has_multiple_supported_coupon_platforms,
          this.redeemCouponPageSettings
        )
      }
    },

    coupon() {
      this.steps = buildSteps(
        this.$auth.loggedIn,
        this.coupon?.has_multiple_supported_coupon_platforms,
        this.redeemCouponPageSettings
      )
    },
  },

  methods: {
    ...mapMutations('coupons', ['setCoupon']),
  },
}
